import { Model } from 'app/model/backendmodel';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Named, Owned } from 'app/model/base/named';
import { SharePointOnlineFileLocation } from 'app/model/dataset/location/sharepoint-online-file.location';
import { FileLocationAdapter } from './file-location.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SharePointOnlineFileLocation)
})
export class SharePointOnlineFileLocationAdapter extends FileLocationAdapter<SharePointOnlineFileLocation, Model.DatasetLocation> {
    public _toResource(store: SharePointOnlineFileLocation): Model.SharePointOnlineFileLocation {
        const resource: Model.SharePointOnlineFileLocation = {
            type: 'SharePointOnlineFileStoreLocation',
            fileName: ValueAdapter.toResource(store, SharePointOnlineFileLocation.FILE_NAME) || undefined,
            folderPath: ValueAdapter.toResource(store, SharePointOnlineFileLocation.FOLDER_PATH) || undefined
        };
        return resource;
    }

    public _toModel(resource: Model.SharePointOnlineFileLocation, owner: Named): SharePointOnlineFileLocation {
        const model = Owned.create<SharePointOnlineFileLocation>(SharePointOnlineFileLocation.MODEL, owner);
        ValueAdapter.toModel(model, SharePointOnlineFileLocation.FILE_NAME, resource.fileName);
        ValueAdapter.toModel(model, SharePointOnlineFileLocation.FOLDER_PATH, resource.folderPath);
        return model;
    }
}
